import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@cloudflare/kumo/styles/standalone'
import App from './App'
import './index.css'

const rootElement = document.getElementById('root')

if (!rootElement) {
  console.error('Root element not found')
} else {
  try {
    createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
    console.log('Immerse Paris Gallery mounted successfully')
  } catch (error) {
    console.error('Failed to mount gallery:', error)
    rootElement.innerHTML = '<div style="padding: 2rem; text-align: center;"><h1>Error Loading Gallery</h1><p>Please refresh the page or check the browser console.</p></div>'
  }
}
